import TopBannerAd from 'components/search/TopBannerAd';
import InlineBannerAd from 'components/search/InlineBannerAd';

const componentMap = {
  inlineBannerAd: InlineBannerAd,
  topBannerAd: TopBannerAd
};

const SearchSlot = ({ slotDetails, ...props }) => {
  const Component = componentMap[slotDetails?.componentName];
  return Component ? <Component slotDetails={slotDetails} {...props} /> : null;
};

export default SearchSlot;
